import React from 'react';

/* ═══════════════════════════════════════════════════
   notesHelpers — helpers shared antara NotesView & QuickNotesPanel
   ═══════════════════════════════════════════════════ */

// Detect URL dalam teks: full http(s) link, ATAU bare link yang mula dgn www./vt./vm.
// (vt.tiktok.com / vm.tiktok.com = TikTok share links). Parse masa render sahaja.
export const URL_REGEX = /(https?:\/\/[^\s]+|(?:www\.|vt\.|vm\.)[a-z0-9.-]+\.[a-z]{2,}[^\s]*)/gi;

/* Kelas pautan lalai — kelas rupa LAMA. Ia dikongsi oleh NotesView dan
   QuickNotesPanel (panel dalam Workspace), jadi menukarnya di sini akan
   menukar rupa panel itu sekali. Rupa v3.9 menghantar kelasnya sendiri
   ('s-link') kerana warnanya datang daripada token tema, bukan Tailwind. */
const KELAS_PAUTAN_LAMA = 'text-indigo-600 dark:text-indigo-400 underline break-all hover:text-indigo-700';

// Render teks dengan URL auto-jadi link tappable.
export const renderTextWithLinks = (text, kelas = KELAS_PAUTAN_LAMA) => {
    if (!text) return null;
    const out = [];
    let last = 0;
    for (const m of text.matchAll(URL_REGEX)) {
        const url = m[0];
        const start = m.index;
        if (start > last) out.push(text.slice(last, start));
        const href = url.startsWith('http') ? url : `https://${url}`;
        out.push(
            React.createElement(
                'a',
                {
                    key: start,
                    href,
                    target: '_blank',
                    rel: 'noopener noreferrer',
                    onClick: (e) => e.stopPropagation(),
                    className: kelas,
                },
                url
            )
        );
        last = start + url.length;
    }
    if (last < text.length) out.push(text.slice(last));
    return out;
};

// Masa relatif dalam Bahasa Melayu
export const formatRelative = (ts) => {
    if (!ts) return '';
    const diff = Math.max(0, Date.now() - ts);
    const min = Math.floor(diff / 60000);
    const hour = Math.floor(min / 60);
    const day = Math.floor(hour / 24);
    if (min < 1) return 'baru sahaja';
    if (min < 60) return `${min} minit lalu`;
    if (hour < 24) return `${hour} jam lalu`;
    if (day === 1) return 'semalam';
    if (day < 7) return `${day} hari lalu`;
    return new Date(ts).toLocaleDateString('ms-MY', { day: 'numeric', month: 'long', year: 'numeric' });
};
